module.exports = __webpack_public_path__ + "assets/img/skin_2.e71f72d5.jpg";